export const APOLLO_CLIENT_V3_RAMP_KEY = 'apollo_client_v3_user';

export const shouldUseApolloClientV3 = (
  featureFlags: Partial<Record<string, boolean>> = typeof window === 'undefined'
    ? {}
    : (window.CONFIG?.FEATURE_FLAGS ?? {})
): boolean => featureFlags[APOLLO_CLIENT_V3_RAMP_KEY] === true;

// Apollo is selected once during page startup. Switching a mounted tree would
// mix contexts and caches from different major versions.
export const isApolloClientV3Enabled = shouldUseApolloClientV3();

export const apolloClientMajorVersion = isApolloClientV3Enabled ? 3 : 2;
